import * as React from 'react';
import { Overlay } from '../components/Overlay';
import { ThumbsGrid } from '../components/ThumbsGrid';
import Layer from '../data/Layer';
import { trackEvent } from 'utils/Tracker';
import { getStoreState, storeDispatch } from '../state/Store';
import { ShapeData } from 'data/FlyerData';
import { promptAnswer } from 'components/PromptView';
import { AddShapeFrameCommand } from 'state/commands/AddShapeFrameCommand';
import { AddMaskCommand } from 'state/commands/AddMaskCommand';

enum ShapeType {
  OVAL = 'oval',
  RECTANGLE = 'rectangle',
  STAR = 'star',
  TRIANGLE = 'triangle',
  POLYGON = 'polygon'
}

const types = [
  ShapeType.RECTANGLE,
  ShapeType.OVAL,
  ShapeType.STAR,
  ShapeType.POLYGON
];

export const ShapeSelector: React.FunctionComponent<{
  layer?: Layer;
  isMask: boolean;
}> = props => {
  const { layer, isMask } = props;

  const didSelectType = async (type: ShapeType) => {
    trackEvent('Add Shape', { type });
    let polygonCorners = 3;
    if (type === ShapeType.POLYGON && isMask) {
      const promptStr = await promptAnswer(
        'How many corners would you like? (3-10)'
      );
      if (promptStr === null) {
        return;
      }
      polygonCorners = Math.max(
        3,
        Math.min(10, parseInt(promptStr.trim(), 10))
      );
    }
    const { width, height } = getStoreState().flyer.resolution;
    const cx = width / 2;
    const cy = height / 2;
    const side = Math.min(width, height) / 5;
    let data: ShapeData;
    switch (type) {
      case ShapeType.OVAL: {
        data = {
          x: (width - side) / 2,
          y: (height - side) / 2,
          width: side,
          height: side,
          isOval: true
        };
        break;
      }
      case ShapeType.STAR: {
        const s = side * 1.5;
        data = [
          { x: 0, y: s * -0.5 },
          { x: s * 0.1123, y: s * -0.1545 },
          { x: s * 0.4755, y: s * -0.1545 },
          { x: s * 0.1816, y: s * 0.059 },
          { x: s * 0.2939, y: s * 0.4045 },
          { x: 0, y: s * 0.191 },
          { x: s * -0.2939, y: s * 0.4045 },
          { x: s * -0.1816, y: s * 0.059 },
          { x: s * -0.4755, y: s * -0.1545 },
          { x: s * -0.1123, y: s * -0.1545 }
        ];
        data.forEach(p => {
          p.x += cx;
          p.y += cy;
        });
        break;
      }
      case ShapeType.TRIANGLE: {
        const w = side * 1.1;
        const h = side * 0.93;
        data = [
          { x: cx, y: cy - h / 2 },
          { x: cx + w / 2, y: cy + h / 2 },
          { x: cx - w / 2, y: cy + h / 2 }
        ];
        break;
      }
      case ShapeType.POLYGON: {
        data = {
          x: (width - side) / 2,
          y: (height - side) / 2,
          width: side,
          height: side,
          corners: polygonCorners
        };
        break;
      }
      default: {
        data = {
          x: (width - side) / 2,
          y: (height - side) / 2,
          width: side,
          height: side
        };
        break;
      }
    }
    if (isMask && layer !== undefined) {
      storeDispatch(new AddMaskCommand(layer.id, data));
    } else {
      storeDispatch(new AddShapeFrameCommand(layer?.id, data));
    }
  };

  return (
    <Overlay fullWidth={true}>
      <ThumbsGrid title="Select shape type">
        {types.map(t => (
          <div onClick={() => didSelectType(t)} key={t}>
            <div className="thumbs-grid-thumb">
              <img src={`/media/shapes-thumbs/shape-${t}.png`} />
            </div>
          </div>
        ))}
      </ThumbsGrid>
    </Overlay>
  );
};



// WEBPACK FOOTER //
// ./src/modals/ShapeSelector.tsx